import { render, staticRenderFns } from "./TransactionTaxDisplay.vue?vue&type=template&id=466f185c&scoped=true&"
import script from "./TransactionTaxDisplay.vue?vue&type=script&lang=js&"
export * from "./TransactionTaxDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466f185c",
  null
  
)

export default component.exports